import App from "@components/App";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "@i18n/i18n";
import { RootProvider } from "./providers/root";
import reportWebVitals from "./reportWebVitals";
import { initGTM } from "@utils/gtm";
import "./utils/firebase";

// Initialize GTM
initGTM();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <RootProvider>
    <App />
  </RootProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
